import React from 'react';
import { useAuthz, useCan } from '../store';
import { Resource, Verb } from '../api/authz';

/**
 * 资源域级页面守卫 (2026-08-31 RBAC), 取代按 isAdmin 判定的 AdminRoute.
 *
 * 菜单隐藏只挡入口, 直接敲 URL 仍能进, 所以受控页面都要包一层本组件;
 * 后端 authz 中间件才是真闸门, 这里只是不给看.
 *
 * 2026-09-12 起前端无条件遵循 RBAC: 按 my-roles 的规则本地判定, 与后端中间件同一套口径
 * (后端开了 RBAC 就真拦, 2026-09-24 起没有"判了不拦"的影子模式).
 */
/** 「无权访问」占位页, PermissionRoute 与 RouteGuard 共用. */
export const DeniedPage = ({ roles }: { roles: string[] }) => (
    <div className="py-16 text-center">
        <div className="text-4xl mb-3">🔒</div>
        <div className="text-base font-medium text-slate-700">无权访问</div>
        <div className="mt-1 text-sm text-slate-500">
            当前角色({roles.join(', ') || '未分配'})无权访问该页面,
            可在顶栏「申请权限」申请对应资源的只读 / 管理权限.
        </div>
    </div>
);

const PermissionRoute = ({
    resource,
    verb = 'get',
    children,
}: {
    resource: Resource;
    verb?: Verb;
    children: React.ReactNode;
}) => {
    const authz = useAuthz();
    const allowed = useCan(resource, verb);

    if (!authz.loaded) {
        return <div className="text-sm text-slate-500">正在校验权限…</div>;
    }
    if (!allowed) {
        return <DeniedPage roles={authz.roles} />;
    }
    return <>{children}</>;
};

export default PermissionRoute;
